import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/member/page', data, {
    trim: true
  })
}

// 查询
export function findAll (data) {
  return request.post('/business/member/findAll', data)
}


export function updateById (data) {
  return request.post('/business/member/updateById', data)
}
